"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SF = function SF(props) {
  var size = props.size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    preserveAspectRatio: "xMidYMid slice",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(.735 0 0 .735 110.882 100)"
  }, /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "230",
    cy: "136",
    fill: "#fff",
    rx: "230",
    ry: "136"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "229.5",
    cy: "137",
    rx: "223",
    ry: "130"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "230.5",
    cy: "138.5",
    fill: "#b3995d",
    rx: "194.5",
    ry: "120"
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "231",
    cy: "136.5",
    fill: "#a00",
    rx: "179",
    ry: "112"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m370.848 121.879h-.492v-4.074h-71c-1.523-7.99-6.121-15.4-12.676-21.186-6.457-7.426-15.844-13.01-26.523-15.131l-4.43-.91c-10.25-2.154-18.34-3.859-50.906-3.695 0 0-6.266-.215-12.344-1.02-1.539-.389-2.891-.855-4.051-1.355.449-2.709 5.41-6.443 11-7.168.582-.105 35.824-6.59 72.102 16.904l.891.574h23.84v-36.484h-4.078v-4.076h-32.719s-3.887 2.967-5.512 4.211c-9.418-2.359-55.559-12.455-95.395 4.984-16.742 6.92-27.133 19.98-26.398 33.24.375 6.686 3.578 12.516 9.109 17.041 4.07 5.08 10.469 9.045 18.805 11.445 11.797 3.398 21.781 4.799 31.465 5.354v16.635h4.082v4.076h12.438c5.152 0 6.477 2.855 6.793 3.918-15.875-1.039-40.023-5.559-57.793-22.008l-.668-.721h-.125c-.98-.936-1.945-1.904-2.887-2.92l-1.063-1.154h-17.895v51.936h4.078v4.07h14.59c2.141.148 8.922-.609 13.602-14.273 7.59 2.641 26.293 8.273 49.328 8.898v32.309c-.805 10.848-24.703 14.246-33.031 14.574l-3.438.133v16.063h4.074v4.07h104.926v-15.367l-2.676-.711c-.48-.121-.934-.246-1.398-.375v-3.516l-3.277-.281c-5.898-.523-10.438-1.547-13.961-2.797-6.594-3.703-7.723-6.703-7.863-7.188v-17.227h30.754c3.246.492 6.027 1.914 8.387 3.766 4.43 5.453 6.445 11.688 6.48 11.789l.785 2.523 2.641.016h.082c.367.922.563 1.508.566 1.539l.785 2.531h16.524v-62.488h-4.074v-4.082h-16.449l-.594 2.863c-4.313 20.762-28.32 20.457-49.668 17.344 4.18-1.137 8.387-2.512 12.582-4.18 11.43-4.543 20.004-10.723 25.355-17.957h46.082c3.215.102 5.945.902 8.242 2.406 4.836 7.094 4.348 17.523 4.344 17.648l-.199 3.777h4.289l-.008.293-.207 3.781 3.789.008h14.578v-48.377h-3.59z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m297.34 134.674h38.195c21.816.695 20.238 27.914 20.238 27.914h11v-41.199h-65.922c.001 0-.156 9.22-3.511 13.285m-77.742 35.187v31.637c-1.133 16.582-36.465 17.957-36.465 17.957v9.027h97.754v-9.027c-29.051-2.512-29.18-17.316-29.18-17.316v-21.125h34.723c15.883 2.266 21.988 22.168 21.988 22.168h10.293v-55.32h-9.945c-6.914 33.324-57.98 18.332-61.758 19.168 0-.001-12.578 3.14-27.41 2.831m30.5-54.427c13.27 3.889 14.504 14.014 6.734 23.494-9.941 9.383-25.125 9.77-25.125 9.77s-51.125 5.527-80.961-26.75h-12.738v44.762h11.164s6.805 1.043 11.168-15.359c0 0 52.496 21.363 102.43 1.539 48.363-19.211 29.957-61.287-3.32-67.881-12.797-2.535-17.887-4.725-54.613-4.535 0 0-6.629-.211-13.086-1.086-20.242-5.059-8.73-18.145 3.141-19.68 0 0 36.469-7.189 74.512 17.451h19.195v-29.317h-27.926l-5.93 4.535s-51.766-14.455-94.75 4.361c-28.891 11.945-34.555 41.824-3 50.92 27.789 8.01 45.504 4.654 73.664 5.729 7.87.301 14.71.611 19.441 2.047m-41.711 18.148h-13.266v-11.879c10.281 0 31.25.084 46.086 0 14.93 0 16.918 8.629 10.629 14.465-5.93 5.502-18.352 9.42-33.055 6.744 0 0-1.211-9.33-10.394-9.33",
    fill: "#fff"
  })));
};

SF.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
SF.defaultProps = {
  size: '100'
};
var _default = SF;
exports["default"] = _default;